export default __webpack_public_path__ + "static/media/showroom38.ac7992cf.webp";